var __vueify_style_dispose__ = require("vueify/lib/insert-css").insert(".ac-btn-primary[data-v-038b83da]:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}")
;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require("babel-runtime/core-js/object/assign");

var _assign2 = _interopRequireDefault(_assign);

var _VerifyWithdrawalOtp = require("./VerifyWithdrawalOtp.vue");

var _VerifyWithdrawalOtp2 = _interopRequireDefault(_VerifyWithdrawalOtp);

var _Loader = require("./Loader.vue");

var _Loader2 = _interopRequireDefault(_Loader);

var _SuccessComponent = require("./SuccessComponent.vue");

var _SuccessComponent2 = _interopRequireDefault(_SuccessComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    WithdrawalOtpVerification: _VerifyWithdrawalOtp2.default,
    Loader: _Loader2.default,
    SuccessComponent: _SuccessComponent2.default
  },
  props: {
    error: { type: String, default: null },
    walletId: { type: Number, required: true },
    agent: { type: Object, default: function _default() {
        return {};
      } },
    headers: { type: Object, default: function _default() {
        return {};
      } },
    currency: { type: String, default: "" }
  },
  data: function data() {
    return {
      showOtpVerification: false,
      currentAgent: {},
      gateways: [],
      selectedGateway: null,
      agentMsisdn: "",
      withdrawalAmount: "",
      showLoader: false,
      showSuccess: false,
      maskedOtpRecipient: "",
      loadingGateways: true
    };
  },
  mounted: async function mounted() {
    await this.loadWithdrawalGateways();
    this.maskedOtpRecipient = this.maskAccountNumber(this.currentAgent.msisdn);
  },

  computed: {
    hasGateways: function hasGateways() {
      return this.gateways.length > 0;
    },
    isBank: function isBank() {
      return !!this.selectedGateway && this.selectedGateway.channel === "bank";
    }
  },
  methods: {
    loadWithdrawalGateways: async function loadWithdrawalGateways() {
      try {
        var response = await Vue.axios.post("/wallet/checkout/withdraw/channels", { account_id: this.walletId, currency: this.currency }, { headers: this.headers });
        this.gateways = response.data.withdrawal_gateways || [];
        this.selectedGateway = this.gateways[0] || null;
      } catch (error) {
        console.error("Failed to load withdrawal gateways:", error);
      } finally {
        this.loadingGateways = false;
      }
    },
    isSelected: function isSelected(gateway) {
      return this.selectedGateway === gateway;
    },
    displayAccount: function displayAccount(gateway) {
      return gateway.channel === "momo" ? this.maskAccountMobileMoneyAcc(gateway.account_number || "") : gateway.account_number;
    },
    handleWithdrawSubmit: async function handleWithdrawSubmit() {

      if (!this.selectedGateway) {
        console.error("No withdrawal gateway selected");
        return;
      }

      try {
        var params = (0, _assign2.default)({
          agent_id: this.currentAgent.id,
          wallet_id: this.walletId,
          currency: this.currency,
          account: this.selectedAccount,
          msisdn: this.agentMsisdn,
          withdrawal_channel: this.withdrawalChannelParam(),
          gateway_id: this.gatewayIdParam(),
          amount: this.withdrawalAmount
        }, this.bankParams());

        var response = await Vue.axios.post("/wallet/checkout/withdraw/proceed", params, { headers: this.headers });

        this.showOtpVerification = true;
      } catch (error) {
        if (error.response && error.response.status === 403) {
          window.location.href = "/wallet/auth";
          return;
        }
        console.error("Withdrawal failed:", error);
      }
    },
    handleOtpVerification: async function handleOtpVerification(otpValue) {
      this.showOtpVerification = false;
      this.showLoader = true;

      try {
        var params = (0, _assign2.default)({
          account_id: this.walletId,
          currency: this.currency,
          msisdn: this.agentMsisdn,
          withdrawal_channel: this.withdrawalChannelParam(),
          gateway_id: this.gatewayIdParam(),
          otp: otpValue,
          amount: this.withdrawalAmount,
          channel: this.selectedGateway.channel,
          callback_url: ""
        }, this.bankParams());

        var response = await Vue.axios.post("/wallet/checkout/withdraw/verify-otp", params, { headers: this.headers });

        if (response.data.success) {
          this.showLoader = false;
          this.showSuccess = true;
        } else if (response.data.message === "Insufficient balance") {
          this.error = "Insufficient balance";
          this.showLoader = false;
          this.showOtpVerification = true;
        }
      } catch (error) {
        this.showLoader = false;
        this.showOtpVerification = true;
        this.error = error;
      }
    },
    gatewayIdParam: function gatewayIdParam() {
      return this.selectedGateway ? this.selectedGateway.gateway_id : null;
    },
    withdrawalChannelParam: function withdrawalChannelParam() {
      return this.isBank ? "bank" : "mpesa";
    },
    bankParams: function bankParams() {
      if (!this.isBank) return {};
      return {
        bank_name: this.selectedGateway.name,
        bank_account_number: this.selectedGateway.account_number,
        account_details: {
          account_number: this.selectedGateway.account_number
        }
      };
    },
    maskAccountNumber: function maskAccountNumber(accountNumber) {
      return accountNumber.replace(/\d(?=\d{3})/g, "*");
    },
    maskAccountMobileMoneyAcc: function maskAccountMobileMoneyAcc(mobileMoneyAccountNumber) {
      return mobileMoneyAccountNumber.replace(/(\d{4})\d+(\d{3})/, "$1******$2");
    }
  },
  watch: {
    agent: {
      immediate: true,
      handler: function handler(agent) {
        if (agent) {
          this.currentAgent = typeof agent === "string" ? JSON.parse(agent) : agent;
          this.agentMsisdn = this.currentAgent.msisdn || "";
        }
      }
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ac-page"},[(_vm.showLoader)?_c('Loader'):_vm._e(),_vm._v(" "),(_vm.showSuccess)?_c('SuccessComponent'):_vm._e(),_vm._v(" "),(!_vm.showLoader && !_vm.showSuccess)?_c('div',{staticStyle:{"display":"flex","justify-content":"space-between","align-items":"center","margin-bottom":"28px"}},[_c('nav',{staticStyle:{"display":"flex","align-items":"center","gap":"6px","font-size":"14px"}},[_c('a',{staticStyle:{"color":"#667085","text-decoration":"none"},attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.$emit('back')}}},[_vm._v("Wallets")]),_vm._v(" "),_c('svg',{attrs:{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"}},[_c('path',{attrs:{"d":"M6 12L10 8L6 4","stroke":"#667085","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})]),_vm._v(" "),_c('span',{staticStyle:{"color":"#2c7be5","font-weight":"500"}},[_vm._v("Withdraw")])]),_vm._v(" "),_c('a',{staticClass:"ac-cancel-link",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.$emit('back')}}},[_vm._v("\n      Cancel\n      "),_c('svg',{attrs:{"width":"26","height":"26","viewBox":"0 0 26 26","fill":"none"}},[_c('rect',{attrs:{"x":"26","y":"26","width":"26","height":"26","rx":"13","transform":"rotate(-180 26 26)","fill":"#F9FAFB"}}),_vm._v(" "),_c('path',{attrs:{"d":"M6.58366 13L19.417 13M13.0003 20L19.417 13L13.0003 6","stroke":"#898989","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])])]):_vm._e(),_vm._v(" "),(!_vm.showLoader && !_vm.showSuccess)?_c('div',{staticStyle:{"flex":"1","display":"flex","align-items":"center","justify-content":"center"}},[_c('div',{staticClass:"ac-login-card",staticStyle:{"border-color":"#dfdfdf"}},[(_vm.error)?_c('div',{staticStyle:{"background":"#fee2e2","border":"1px solid #fca5a5","border-radius":"8px","padding":"10px 14px","margin-bottom":"16px","font-size":"14px","color":"#dc2626"}},[_vm._v("\n        "+_vm._s(_vm.error)+"\n      ")]):_vm._e(),_vm._v(" "),(_vm.showOtpVerification)?_c('WithdrawalOtpVerification',{attrs:{"maskedOtpRecipient":_vm.maskedOtpRecipient},on:{"verify-otp":_vm.handleOtpVerification}}):_c('form',{staticStyle:{"display":"flex","flex-direction":"column","justify-content":"space-between","height":"auto","gap":"32px"},on:{"submit":function($event){$event.preventDefault();return _vm.handleWithdrawSubmit.apply(null, arguments)}}},[_c('div',{staticStyle:{"display":"flex","flex-direction":"column","gap":"32px"}},[_c('div',{staticStyle:{"display":"flex","flex-direction":"column","gap":"4px"}},[_c('p',{staticStyle:{"font-size":"16px","font-weight":"600","color":"#000007","line-height":"normal","margin":"0"}},[_vm._v("\n              Withdraw\n            ")]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"14px","font-weight":"500","color":"#5f6368","line-height":"22px","letter-spacing":"0.14px","margin":"0"}},[_vm._v("\n              Select from your list of accounts\n            ")])]),_vm._v(" "),_c('div',[_c('label',{staticClass:"ac-label",attrs:{"for":"amount"}},[_vm._v("Amount")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.withdrawalAmount),expression:"withdrawalAmount"}],staticClass:"ac-input",staticStyle:{"border-radius":"6px"},attrs:{"type":"number","id":"amount","placeholder":"Enter amount","min":"1","step":"any","required":""},domProps:{"value":(_vm.withdrawalAmount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.withdrawalAmount=$event.target.value}}})]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","flex-direction":"column","gap":"12px"}},[(!_vm.loadingGateways && !_vm.hasGateways)?_c('p',{staticStyle:{"font-size":"14px","color":"#dc2626","margin":"0"}},[_vm._v("\n              No withdrawal gateways are available for this wallet.\n            ")]):_vm._e(),_vm._v(" "),_vm._l((_vm.gateways),function(gateway){return _c('div',{key:gateway.gateway_id,style:(_vm.isSelected(gateway)
                  ? 'cursor:pointer; background:#fafafa; border:2px solid #000; border-radius:12px; padding:11px 16px; display:flex; align-items:center; justify-content:space-between;'
                  : 'cursor:pointer; background:#fafafa; border:1px solid #ebefed; border-radius:12px; padding:12px 16px; display:flex; align-items:center; justify-content:space-between;'),on:{"click":function($event){_vm.selectedGateway = gateway}}},[_c('span',{staticStyle:{"font-size":"14px","font-weight":"500","color":"#1a1c1b","line-height":"normal"}},[_vm._v("\n                "+_vm._s(gateway.name)+": "+_vm._s(_vm.displayAccount(gateway))+"\n              ")]),_vm._v(" "),(_vm.isSelected(gateway))?_c('span',{staticStyle:{"flex-shrink":"0","line-height":"0"}},[_c('svg',{attrs:{"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"}},[_c('rect',{attrs:{"width":"20","height":"20","rx":"10","fill":"#9DBD59"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"10","cy":"10","r":"10","fill":"#9DBD59"}}),_vm._v(" "),_c('path',{attrs:{"d":"M14.7621 6.9541L8.21447 13.5017L5.23828 10.5255","stroke":"white","stroke-width":"1.19048","stroke-linecap":"round","stroke-linejoin":"round"}})])]):_vm._e()])})],2)]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","justify-content":"flex-end"}},[_c('button',{staticClass:"ac-btn-primary",attrs:{"type":"submit","disabled":!_vm.hasGateways}},[_vm._v("\n            Proceed\n          ")])])])],1)]):_vm._e()],1)}
__vue__options__.staticRenderFns = []
__vue__options__._scopeId = "data-v-038b83da"
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  module.hot.dispose(__vueify_style_dispose__)
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-038b83da", __vue__options__)
  } else {
    hotAPI.reload("data-v-038b83da", __vue__options__)
  }
})()}